export default __webpack_public_path__ + "static/media/oursong.f8472df4.gif";